module.exports = __webpack_public_path__ + "static/media/kara-1040.42d05770.jpg";